import React from 'react'
import CourseContainer from '../components/containers/Settings/Courses/CourseContainer'

const Post = () => {
    return (
        <CourseContainer />
    )
};

export default Post;